var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSizeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 34,
    viewBox: "0 0 31 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5347 0.797063C14.3661 -0.265688 16.6244 -0.265688 18.4653 0.797063L28.0301 6.31941C28.9221 6.83181 29.6432 7.56263 30.1556 8.40714L15.5 16L0.834908 8.40714C1.34731 7.56263 2.06845 6.83181 2.9604 6.31941L12.5347 0.797063ZM30.9905 11.2916L31 11.453V22.5074C31 24.6235 29.8709 26.5781 28.0301 27.6408L18.4653 33.1634C17.9624 33.4576 17.4216 33.6665 16.8712 33.7993V18.3514L30.9905 11.2916ZM13.9106 33.7423C13.4361 33.6095 12.9712 33.4196 12.5347 33.1634L2.9604 27.6408C1.12905 26.5781 0 24.6235 0 22.5074V11.453V11.2916L13.9106 18.247V33.7423Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeIcon);
export default __webpack_public_path__ + "static/media/SizeIcon.05c223bec37a4c0a669398641a325f71.svg";
export { ForwardRef as ReactComponent };